import React from "react";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Button } from "@amzn/stencil-react-components/button";
import { H3, Text } from "../typography";
import { IconQuestionCircle } from "@amzn/stencil-react-components/icons";
import { withTooltip, TooltipAlignment } from "@amzn/stencil-react-components/tooltip";
import { HVH_COLORS } from "../../config/palette";
import { Link } from "@amzn/stencil-react-components/link";
import "./styles.scss";

const IconWithTooltip = withTooltip()(IconQuestionCircle);
interface SdaHeaderProps {
  startDate?: string;
  startTime?: string;
  pending?: boolean;
  tentative?: boolean;
  onViewDetailsClick: () => void;
  onChangeClick: () => void;
}

const linkStyle = {
  cursor: "pointer",
};

export const SdaHeader = ({
  startDate,
  startTime,
  pending,
  tentative,
  onViewDetailsClick,
  onChangeClick,
}: SdaHeaderProps) => {
  const message = tentative ? (
    <Text>
      Congratulations! Your tentative{" "}
      <span className="tooltip-icon-in-text">
        <IconWithTooltip
          tooltipAlignment={TooltipAlignment.Center}
          tooltipPosition="bottom"
          tooltipText="Your first day is contingent on
        the results of your background check and drug test."
        />
      </span>{" "}
      first day is {startDate} at {startTime}. Confirmed first day details will be shared once you complete background
      check and drug test screenings.
    </Text>
  ) : (
    <Text>
      Congratulations! Your first day is confirmed for {startDate} at {startTime}.
    </Text>
  );

  return (
    <Col gridGap="1rem" backgroundColor={HVH_COLORS.NEUTRAL_10} padding="1rem" style={{ borderRadius: "0.5rem" }}>
      <Row justifyContent="space-between">
        <H3 fontSize="T200" color={HVH_COLORS.NEUTRAL_90} fontWeight="bold">
          Your First Day Onsite
        </H3>
        {!pending && (
          <Link fontSize="T200" color={HVH_COLORS.PRIMARY_70} textDecoration="none" style={linkStyle}>
            <Text fontWeight="bold" onClick={onChangeClick}>
              Change
            </Text>
          </Link>
        )}
      </Row>
      {pending && <Text>Pending</Text>}
      {!pending && message}
      {!pending && <Button onClick={onViewDetailsClick}>What to expect</Button>}
    </Col>
  );
};
